import { Stage } from '../courses';
import { CommonRequestOptions } from '../makeRequest';
import {
   StageCompletionRecord,
   CourseAssignmentDetails,
   getCourseAssignmentDetails,
} from './get-course-assignment-details';

// Course assignment with several calculated attributes
export type CourseAssignmentUserDetails = CourseAssignmentDetails & {
   overallCompletion: number;
   stageCompletionRecords: UserStageCompletionRecord[];
   detailsType: 'user';
   userId: number;
   isTeamMemberAssignment: boolean;
};

export function isCourseAssignmentUserDetails(x: any): x is CourseAssignmentUserDetails {
   return x?.detailsType === 'user';
}

export async function getCourseAssignmentUserDetails(
   course_assignmentid: number | null,
   userid: number,
   common?: CommonRequestOptions
) {
   if (course_assignmentid === null) return null;
   const courseAssignment = await getCourseAssignmentDetails(course_assignmentid, common);
   return calculateCourseAssignmentUserDetails(courseAssignment, userid);
}

export type UserStageCompletionRecord = StageCompletionRecord & {
   completionRecordType: 'user';
   quiz_attempts_remaining?: number;
};

export function isUserStageCompletionRecord(x: any): x is UserStageCompletionRecord {
   return x && x.completionRecordType === 'user';
}

function calculateCourseAssignmentUserDetails(
   courseAssignment: CourseAssignmentDetails,
   userid: number
): CourseAssignmentUserDetails {
   const userStatus = courseAssignment.completion_status.find(userCompletionStatus => {
      return userCompletionStatus.userid === userid;
   });

   const stageCompletionRecords: UserStageCompletionRecord[] = (userStatus?.stages || []).map(
      completionRecord => ({
         ...completionRecord,
         completionRecordType: 'user',
      })
   );

   const stagesCompleted = stageCompletionRecords.reduce(
      (stagesCompleted, completionRecord) =>
         stagesCompleted + (completionRecord.status === 'completed' ? 1 : 0),
      0
   );

   const overallCompletion = percentage(stagesCompleted, courseAssignment.course.stages.length);

   return {
      detailsType: 'user',
      isTeamMemberAssignment: courseAssignment.assignee_teamid !== null,
      userId: userid,
      overallCompletion,
      stageCompletionRecords,
      ...courseAssignment,
   };
}

function percentage(numerator: number, denomenator: number): number {
   return denomenator ? Math.round((numerator / denomenator) * 100) : 0;
}
